<template>
	<div>

		<!-- #Inicio# Modal de informações -->
		<vuestic-modal :show.sync="modal.show" ref="smallModal" v-bind:small="false" :cancelClass="'none'" okText="Fechar" cancelText="Fechar">
			<div slot="title">Informações</div>
			<div v-show="modal.load">
				<div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
					<div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
						<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
					</div>
				</div>
			</div>
			<div v-show="!modal.load">
				<vuestic-tabs :names="['Dados Básicos', 'Endereço']" ref="tabs">
					<div slot="Dados Básicos">
						<div class="row">
							<div class="col-md-3" style="text-align:center;">
								<img width="100" :src="'data:image/jpg;base64, ' + modal.conteudo.photoApp" alt="Foto">
							</div>
							<div class="col-md-3">
								<strong class="font-weight-bold">CPF:</strong><br>
								<span class="circle badge-success" v-if="modal.conteudo.flg_ativo"></span>
								<span class="circle badge-danger" v-if="!modal.conteudo.flg_ativo"></span>
								{{ modal.conteudo.cpf }}
							</div>
							<div class="col-md-3">
								<strong class="font-weight-bold">Nome:</strong><br>
								{{ modal.conteudo.nome }}
							</div>
							<div class="col-md-3">
								<!--
								<strong class="font-weight-bold">E-mail:</strong><br>
								{{ modal.conteudo.email }}
								-->
							</div>
						</div>
						<br>
						<div class="row">
							<div class="col-md-4">
								<!--
								<strong class="font-weight-bold">CNH:</strong><br>
								{{ modal.conteudo.cnh }}
								-->
							</div>
							<div class="col-md-4">
								<!--
								<strong class="font-weight-bold">Telefone/Celular:</strong><br>
								{{ modal.conteudo.telefone }}
								-->
							</div>
							<div class="col-md-4">
								<!--
								<strong class="font-weight-bold">Data de nascimento:</strong><br>
								{{ utils.formatDate(modal.conteudo.data_nascimento, true) }}
								-->
							</div>
						</div>
					</div>
					<div slot="Endereço">
						<div v-if="modal.conteudo.endereco_instrutor">
							<div class="row">
								<div class="col-md-4">
									<strong class="font-weight-bold">UF:</strong><br>
									{{ modal.conteudo.endereco_instrutor.endereco.uf }}
								</div>
								<div class="col-md-4">
									<strong class="font-weight-bold">Cidade:</strong><br>
									{{ modal.conteudo.endereco_instrutor.endereco.cidade }}
								</div>
								<div class="col-md-4">
									<strong class="font-weight-bold">Bairro:</strong><br>
									{{ modal.conteudo.endereco_instrutor.endereco.bairro }}
								</div>
							</div>
							<br>
							<div class="row">
								<div class="col-md-4">
									<strong class="font-weight-bold">Logradouro:</strong><br>
									{{ modal.conteudo.endereco_instrutor.endereco.logradouro }}
								</div>
								<div class="col-md-4">
									<strong class="font-weight-bold">Número:</strong><br>
									{{ modal.conteudo.endereco_instrutor.numero }}
								</div>
								<div class="col-md-4">
									<strong class="font-weight-bold">CEP:</strong><br>
									{{ modal.conteudo.endereco_instrutor.endereco.cep }}
								</div>
							</div>
							<br>
							<div class="row">
								<div class="col-md-12">
									<strong class="font-weight-bold">Complemento:</strong><br>
									{{ modal.conteudo.endereco_instrutor.complemento }}
								</div>
							</div>
						</div>
					</div>
				</vuestic-tabs>
			</div>
		</vuestic-modal>
		<!-- #Fim# Modal de informações -->

		<!-- #Início# Modal -->
		<vuestic-modal :show.sync="modal.show" ref="fileModal" v-bind:small="false" cancelClass="none" okClass="none">
			<vuestic-tabs :names="['Filtro']" ref="tabs">
				<div slot="Filtro">
					<div class="row">
						<div class="col-md-6">
							<DateIconGroup idInput="data_ini" iconInput="fa-calendar" labelInput="Data Inicial">(AAAA-MM-DD)</DateIconGroup>
						</div>
						<div class="col-md-6">
							<DateIconGroup idInput="data_end" iconInput="fa-calendar" labelInput="Data Final">(AAAA-MM-DD)</DateIconGroup>
						</div>
					</div>
					<div class="row justify-content-center">
						<button class="btn btn-primary" @click="getfile">Download {{ this.fileExt }}</button>
					</div>
				</div>
			</vuestic-tabs>
		</vuestic-modal>
		<!-- #Fim# Modal -->

		<!-- #Início# Legenda com barra de pesquisa-->
		<div class="row">
			<div class="col-md-4">
				<span class="circle badge-success"></span>&nbsp;Ativos&nbsp;&nbsp;
				<span class="circle badge-danger"></span>&nbsp;Inativos&nbsp;&nbsp;&nbsp;&nbsp;
				<i alt="Download PDF" @click="openModal('instrutores', 'pdf')" id="downloadButton" class="fa fa-file-pdf-o">
					<span class="tooltiptext">Download PDF</span>
				</i>
				&nbsp;&nbsp;
				<i @click="openModal('instrutores', 'xlsx')" id="downloadButton" class="fa fa-file-excel-o">
					<span class="tooltiptext">Download XLSX</span>
				</i>
				&nbsp;&nbsp;
				<i @click="openModal('instrutores', 'txt')" id="downloadButton" class="fa fa-file-text-o">
					<span class="tooltiptext  ">Download TXT</span>
				</i>
				<hr>
				<i class="fa fa-group"></i>&nbsp;&nbsp;
				{{ table.data.length == 1 ? table.data.length + " Instrutor" : table.data.length + " Instrutores"}}
			</div>
			<div class="col-md-4 text-center">
				<button :disabled="table.load" class="btn btn-micro btn-info" id="btn" type="button" @click="atualizarInstrutores">
					<i id="consultButton" class="fa fa-refresh pr-3 icon-branco"></i>
					Atualizar Instrutores
				</button>
			</div>
			<div class="col-md-4">
				<fieldset>
					<div class="form-group with-icon-left">
						<div class="input-group">
							<input @input="debounceInput" id="search" autocomplete="off" required>
							<label class="control-label" ref="search" for="search">Procurar...</label><i class="bar"></i>
							<i class="fa icon-left input-icon fa-search"></i>
						</div>
					</div>
				</fieldset>
			</div>
		</div>
		<!-- #Fim# Legenda com barra de pesquisa -->

		<!--Botões da paginação-->
		<div class="row">
      <div class="col mx-auto">
        <pagination
          :source="pagination"
          @navigate="navigate"
          class="pagination justify-content-center"
        ></pagination>
      </div>
    </div>
		<!--Botões da paginação-->

		<!-- #Início# Tabela-->
		<div class="row">
			<div class="col-md-12">
				<table class="table table-striped table-bordered table-responsive-sm text-center">
					<thead>
						<tr>
							<th v-for="th in tableOptions.thead" scope="col" :key="th.id" style="min-width: 250px;">
								<span class="coluna" @click="ordenar(th, $event)">
									{{ th }}
									<span class="seta-cima" v-show="hover === 'asc' + th" v-bind:id="'asc' + th" ></span>
									<span class="seta-baixo" v-show="hover === 'desc' + th" v-bind:id="'desc' + th"></span>
								</span>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-show="table.load">
							<td colspan="6" class="text-center">
								<div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
									<div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
										<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
										</component>
									</div>
								</div>
							</td>
						</tr>
						<tr v-show="!table.load" v-for="dados in table.data" class="tb-linha" :key="dados.id">
							<td>
								<span class="circle badge-success" v-if="dados.flg_ativo"></span>
								<span class="circle badge-danger" v-if="!dados.flg_ativo"></span>
							</td>
							<td>{{ dados.nome }}</td>
							<td>{{ dados.cpf }}</td>
							<td>
								<div class="buttons-td">
									<button title="Desativar instrutor" class="action-button" v-if="dados.flg_ativo" @click="atualizaStatus(dados.id_instrutor, 'desativar')">
										<i class="fa fa-lock"></i>
									</button>
	
									<button title="Ativar instrutor" class="action-button" v-if="!dados.flg_ativo" @click="atualizaStatus(dados.id_instrutor, 'ativar')">
										<i class="fa fa-unlock"></i>
									</button>
	
									<button title="Ver informações do instrutor" class="action-button" @click="detalhes(dados.id_instrutor)">
										<i class="fa fa-info"></i>
									</button>
	
									<button title="Atualizar instrutor" class="action-button" :disabled="!dados.flg_ativo" @click="paginaEdicao(dados.id_instrutor)">
										<i class="fa fa-edit"></i>
									</button>
								</div>
							</td>
						</tr>
						<tr v-show="table.data.length === 0 && !table.load">
							<td colspan="6" class="text-center">Nenhum registro encontrado.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!-- #Fim# Tabela -->

		<!-- #Início# Botões da paginação-->
		<div class="row">
      <div class="col mx-auto">
        <pagination
          :source="pagination"
          @navigate="navigate"
          class="pagination justify-content-center"
        ></pagination>
      </div>
    </div>
		<!-- #Fim# Botões da paginação-->

	</div>
</template>

<script>
	import InstrutoresController from './InstrutoresController'
	import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
	import * as spinners from 'epic-spinners'
	import urlApi from '../../router/urlApi'
	import utils from '../../services/utils'
	import _ from 'lodash'
	import pagination from "../pagination/pagination.vue";

	window._ = require('lodash')

	export default {
		name: 'TableInstrutores',
		components: {
			...spinners,
			DateIconGroup,
			pagination,
		},
		data () {
			return {
				pagination: '',
				consult: "",
				modal: {
					show: false,
					load: false,
					conteudo: {}
				},
				url: urlApi + '/instrutores/ordenar',
				tableOptions: { 'thead': ['#', 'Nome', 'CPF', 'Ações'] },
				search: '',
				table: {
					currentPage: '',
					data: '',
					firstPageUrl: '',
					from: '',
					lastPage: '',
					lastPageUrl: '',
					nextPageUrl: '',
					path: '',
					perPage: '',
					prevPageUrl: '',
					to: '',
					total: '',
					pages: [],
					load: true
				},
				utils: utils,
				selecionado: '',
				ordem: '',
				hover: '',
			}
		},
		mounted () {
			this.loadData()
      this.$refs.search.focus()
		},
		methods: {
			async navigate (page) {
				this.table.load = true

				await this.$http.get(`${this.consult}&page=${page}`).then(this.callbackDataPaginate)
			},
			callbackDataPaginate (response) {
				let responseData = response.data
				this.table.currentPage = responseData.current_page
				this.table.data = responseData.data
				this.table.firstPageUrl = responseData.first_page_url
				this.table.from = responseData.from
				this.table.lastPage = responseData.last_page
				this.table.lastPageUrl = responseData.last_page_url
				this.table.nextPageUrl = responseData.next_page_url
				this.table.path = responseData.path
				this.table.perPage = responseData.per_page
				this.table.prevPageUrl = responseData.prev_page_url
				this.table.to = responseData.to
				this.table.total = responseData.total

				this.table.pages = []
				for (let i = 1; i <= (responseData.last_page); i++) {
					this.table.pages.push(i)
				}

				this.items = this.table.data
				this.pagination = responseData
				this.table.load = false;

			},
			loadData () {
				this.table.load = true

				const url = this.url + '?search=' + this.search
				this.consult = url
				this.$http.get(url).then(this.callbackDataPaginate)
			},
			loadDataOrder (campo, ordenacao) {
				this.table.load = true
				this.$http.get(this.url + '?ordem=' + this.ordem + '&nome=' + this.selecionado + '&search=' + this.search).then(this.callbackDataPaginate)
			},

			atualizarInstrutores () {
				let self = this
				self.table.load = true
				self.$http.get(urlApi + '/getran/atualizar/instrutores').then(function (response) {
					self.table.data = response.data.dados
					self.table.load = false
				}).catch(function (error) {
					self.table.load = false
					InstrutoresController.launchToast('fa-times', error.data.dados, 'top-center')
				})
			},

			debounceInput: _.debounce(function (e) {
				this.search = e.target.value
				this.loadData()
			}, 1000),

			detalhes: function (idInstrutor) {
				let self = this
				this.$refs.smallModal.open()
				self.modal.load = true
				self.modal.conteudo = {}
				InstrutoresController.getInstrutorById(idInstrutor, function (response) {
					self.modal.conteudo = response.data.dados
					self.modal.load = false
				})
			},

			atualizaStatus: function (idInstrutor, status) {
				let self = this
				InstrutoresController.atualizaStatus(idInstrutor, status, function () {
					self.loadData()
				})
			},

			paginaEdicao (idInstrutor) {
				InstrutoresController.paginaEdicao(idInstrutor)
			},

			openModal (entity, ext) {
				this.fileName = entity
				this.fileExt = ext
				this.$refs.fileModal.open()
			},
			posicao(index){
				let distancia = index - this.table.currentPage;
				console.log(distancia);
				if(distancia > -3 && distancia < 1){
					return true;
				}
				return false;
			},

			getfile () {
				var ini = document.getElementById('data_ini').value
				var end = document.getElementById('data_end').value

				if (!ini || !end) {
					InstrutoresController.launchToast('fa-times', 'Ops! Preencha as datas corretamente!')
					return
				}

				if (this.fileExt === 'pdf') {
					utils.generatePDF(this.fileName, ini, end)
					this.$refs.fileModal.close()
				} else {
					utils.generateTXTorXLSX(this.fileName, this.fileExt, ini, end)
					this.$refs.fileModal.close()
				}
			},

			ordenar: function (campo, event) {
				if (campo === "Ações" || campo === "#") {
					return
				}

				var id = campo
				campo = campo.toLowerCase()
				// campo = campo === "inicio do processo" ? 'created_at' : campo;

				if (campo === this.selecionado) {
					this.ordem = this.ordem === 'desc' ? 'asc' : 'desc'
					this.loadDataOrder()
				} else {
					this.selecionado = campo
					this.ordem = 'asc'
					this.loadDataOrder()
				}

				this.hover = document.getElementById(this.ordem + id).id

				console.log('hover: ' + this.hover)
			}
		}
	}
</script>

<style type="scss" scoped>
	.buttons-td {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		gap: 1rem;
	}

	.action-button {
		all: unset;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

		.fa {
			width: 35px;
      height: 35px;
      line-height: 15px;
      margin: 0px;
			color: white;
			padding: 10px;
      border-radius: 50%;
      box-shadow: black;
		}

		.fa-lock {
      background-color: #dc3545;
      border-color: #dc3545;
    }

		.fa-info {
      background-color: #ffc20e;
      border-color: #ffc20e;
    }

		.fa-unlock {
      background-color: #20c997;
      border-color: #20c997;
    }

		.fa-edit {
      background-color: #4ab2e3;
      border-color: #4ab2e3;
    }

		&:not(:disabled) {
			.fa-user-plus:hover {
				background-color: #4ab3e377;
			}

			.fa-pencil:hover {
				background-color: #97d3c7;
			}

			.fa-eraser:hover {
				background-color: #dc354683;
			}

			.fa-eye:hover {
				background-color: #ffc30eaa;
			}
		}
	}

	.tb-opcoes {
		display: flex;
		/* position: absolute; */
		/* right: 20px; */
    margin-left: 65px;
		margin-top: 2px;
	}
/*
	.tb-linha:hover .tb-opcoes {
		display: block;
	} */

	@media (max-width: 1200px) {
		.tb-opcoes {
			display: block;
		}
	}

	.circle {
		width: .75rem;
		height: .75rem;
		border-radius: 50%;
		display: inline-block;
	}

	.coluna{
		cursor: pointer;
	}

	.seta-cima:before {
		content: "";
		display: inline-block;
		vertical-align: middle;
		margin: 0;
		width: 0;
		height: 0;

		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-bottom: 5px solid rgb(34, 143, 233);
	}

	.seta-baixo:before {
		content: "";
		display: inline-block;
		vertical-align: middle;
		margin:0;
		width: 0;
		height: 0;

		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 5px solid rgb(34, 143, 233);
	}
</style>
